import OspreySendRecepients from './test-send-mail'
import OspreyTestEmails from './test-emails'

export default class TestSend {

    send(dataKey) {
        return new OspreySendRecepients(dataKey)
    }

    getEmails(dataKey) {
        return new OspreyTestEmails(dataKey)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/test-send/index.js